import React from 'react';
import { Button, IconButton, Tooltip } from '@material-ui/core';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import LowPriorityIcon from '@material-ui/icons/LowPriority';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { useLocalizedMessage } from '../../../../util/useLocalizedMessage';
import styles from './Workspace.module.scss';

const BlockActions = ({ disabled, canMoveUp, canMoveDown, onUp, onDown, onDuplicate, onMove, onDelete }) => {
  const t = useLocalizedMessage();
  const actions = [
    ['moveUp', ArrowUpwardIcon, onUp, disabled || !canMoveUp],
    ['moveDown', ArrowDownwardIcon, onDown, disabled || !canMoveDown],
    ['duplicate', FileCopyOutlinedIcon, onDuplicate, disabled],
    ['moveTo', LowPriorityIcon, onMove, disabled],
  ];
  return <div className={styles.blockActions} aria-label={t('experience.design.blockActions')}>
    {actions.map(([name, Icon, onClick, isDisabled]) => <Tooltip key={name} title={t(`experience.design.${name}`)}>
      <span><IconButton size="small" disabled={isDisabled} onClick={onClick} aria-label={t(`experience.design.${name}`)}><Icon fontSize="small" /></IconButton></span>
    </Tooltip>)}
    <Button size="small" className={styles.removeBlock} startIcon={<DeleteOutlineIcon />} onClick={onDelete} disabled={disabled}>{t('experience.design.remove')}</Button>
  </div>;
};

export default BlockActions;
